// dbHata.js — VERITABANI HATASINI OKUNUR CUMLEYE CEVIRIR (6 Eyl 2026)
//
// 🔑 Serkan sahada iki kez yakaladı: ekranda
//    *"duplicate key value violates unique constraint
//      crew_qualifications_pilot_id_ac_type_key"*
//    yazıyordu. Bu cümle kullanıcıya NE OLDUĞUNU da NE YAPACAĞINI da
//    söylemiyor. Serkan: *"EVET böyle olsun"* — tanınan hatalar Türkçesi
//    değil, İNSANCA yazılsın.
//
// 🔴 İLKE 1 SINIRI: TANIMADIĞIMIZ hatayı YORUMLAMAYIZ. Eşleşme yoksa
//    sunucunun kendi metni AYNEN gösterilir ve `taninan:false` döner —
//    "her hata için bir cümle uydur" yaklaşımı, yanlış teşhisi doğru
//    teşhis gibi gösterirdi.
//
// Kısıt adları UYDURULMADI: 6 Eyl 2026'da canlı veritabanından çekildi
// (`pg_constraint`, 119 kısıt). Yeni kısıt eklenince buraya da eklenir;
// eklenmezse sistem susmaz, sunucunun metnini gösterir.

/** Kısıt adı → ne olduğu ve ne yapılacağı. */
const KISITLAR = {
  // ── benzersizlik ────────────────────────────────────────────────
  crew_qualifications_pilot_id_ac_type_key:
    'This pilot already has a qualification for this aircraft type. '
    + 'Edit the existing qualification instead of adding a second one.',
  home_bases_pilot_id_unique:
    'This pilot already has a home base. Edit the existing one instead of adding another.',
  ftl_off_types_customer_id_code_key:
    'An off-duty type with this code already exists for this company.',
  training_catalog_customer_id_code_key:
    'A training item with this code already exists for this company.',
  duty_locations_customer_id_country_code_city_key:
    'This duty location is already defined for this company.',
  ftl_rulesets_name_key:  'A rule set with this name already exists.',
  pilot_stats_pilot_id_key: 'Statistics for this pilot already exist.',
  flt_report_plan_id_key: 'A flight report already exists for this plan.',
  uq_archived_plan:       'This flight has already been archived.',

  // ── ATPL & MED (6 Eyl 2026'da eklendi) ──────────────────────────
  plm_tml_chk:
    'TML is selected but no expiry date was given. '
    + 'A TML certificate expires on the date printed on it, so that date is required.',
  plm_ssl_chk:
    'SSL is selected but its text was not entered. '
    + 'The restriction is written on the certificate and the system cannot read it.',
  plm_oal_chk:
    'OAL is selected but no aircraft type was given. The code says nothing on its own.',
  plm_limit_class_chk:
    'This limitation does not apply to the selected medical class. '
    + 'OML and OCL are class 1 only; OSL, OPL, ORL and VCL are class 2 and LAPL only.',
  plm_limits_chk:
    'Unknown limitation code. Only the codes listed in AMC2 MED.B.001 can be recorded.',
  plm_elp_chk: 'ELP level must be between 1 and 6.',

  // ── diger kontroller ────────────────────────────────────────────
  crew_qualifications_seat_check: 'Seat must be one of the defined values.',
  crew_qualifications_hand_check: 'Hand must be one of the defined values.',
  crew_duties_status_check:       'Duty status must be one of the defined values.',
  crew_duties_duty_type_check:    'Duty type must be one of the defined values.',
  aircraft_min_flight_crew_ck:    'Minimum flight crew must be a positive number.',
  // ── ortak uçak tipi listesi (30 Eyl 2026; adlar 20260930c/f'den, yerel pg_constraint ile doğrulandı)
  aircraft_types_tekil: 'This type (code, manufacturer and model) is already in the list.',
  aircraft_types_designator_check: 'The ICAO type code must be 2 to 4 capital letters or digits.',
  aircraft_types_kaynak: 'A type added by hand needs its source (ICAO Doc 8643 or FAA JO 7360.1) and a reason.',
  aircraft_types_manufacturer_check: 'Manufacturer is required.',
  aircraft_types_model_check: 'Model is required.',
  // ── ortak meydan listesi (30 Eyl 2026; adlar 20260930h'den, yerel pg_constraint ile doğrulandı)
  // Canlıda birincil anahtarın adı airports_new_pkey (30 Eyl 2026'da ölçüldü — tablo 12 Tem'de
  // airports_new'den yeniden adlandırıldı, kısıtın adı kaldı).
  airports_new_pkey: 'This ICAO code is already in the airport list.',
  airports_icao_ck: 'The ICAO code must be 4 capital letters.',
  airports_koordinat_ck: 'Latitude must be between -90 and 90, longitude between -180 and 180.',
  airports_go2_ekleme_ck: 'An airport added by GO2 needs a name, coordinates, an elevation, a time zone and a reason.',
  airports_kapanis_ck: 'Closing an airport needs a reason.',
  ftl_rulesets_engine_type_check: 'Unknown rule set engine type.',
  pilot_trainings_status_check:   'Training status must be one of the defined values.',
  efb_documents_status_check:     'Document status must be one of the defined values.',
};

/** Kısıt adını mesajın içinden çeker: `... constraint "xxx"` */
const kisitAdi = (m) => (m.match(/constraint\s+"([^"]+)"/i) || [])[1] || null;

/**
 * @param {string|Error|{message:string}} hata
 * @returns {{ metin:string, taninan:boolean, ham:string }}
 *   `taninan:false` ise `metin` SUNUCUNUN KENDİ METNİDİR — yorum katılmamıştır.
 */
export function dbHata(hata) {
  const ham = (typeof hata === 'string' ? hata : hata?.message || '') || 'Unknown error';
  const d = (m, taninan = true) => ({ metin: m, taninan, ham });

  // 1) Adı bilinen kısıt — en kesin eşleşme.
  const ad = kisitAdi(ham);
  if (ad && KISITLAR[ad]) return d(KISITLAR[ad]);

  // 2) Adını tanımasak da TÜRÜNÜ biliyoruz. Burada iddia ölçülüdür:
  //    "hangi alan" demeyiz, çünkü bilmiyoruz.
  if (/duplicate key value/i.test(ham)) {
    return d('This record already exists. '
      + (ad ? `A uniqueness rule (${ad}) does not allow a second one.`
            : 'A uniqueness rule does not allow a second one.'));
  }
  if (/violates foreign key constraint/i.test(ham)) {
    return d('This record is linked to another record. '
      + 'Either the record it refers to is missing, or something still depends on it.');
  }
  if (/violates check constraint/i.test(ham)) {
    return d('A value is outside what this field allows'
      + (ad ? ` (${ad}).` : '.'));
  }
  if (/violates not-null constraint/i.test(ham)) {
    const alan = (ham.match(/column "([^"]+)"/i) || [])[1];
    return d(alan ? `"${alan}" is required and was left empty.` : 'A required field was left empty.');
  }

  // 3) Şema önbelleği — kolon yok. Bunu bugün Serkan yaşadı: sürümün
  //    migration'ı koşulmadan form o kolonu yazmaya çalışıyordu.
  if (/schema cache|could not find the '.*' column/i.test(ham)) {
    return d('A column this form writes is missing in the database. '
      + 'The migration for this release has not been run yet — run it, then save again.');
  }

  // 4) Yetki / RLS.
  if (/permission denied|row-level security|violates row-level/i.test(ham)) {
    return d('You are not allowed to make this change. '
      + 'Either your role does not permit it, or the record belongs to another company.');
  }

  // 5) Oturum.
  if (/jwt|token|session/i.test(ham) && /expired|invalid/i.test(ham)) {
    return d('Your session has expired. Log out and log in again, then retry.');
  }

  // 6) TANIMIYORUZ — sunucunun kendi metni, yorumsuz (İlke 1).
  return d(ham, false);
}
